import { Colors, Services } from '@sigma-frontend-libs/commons'
import { TaskStates } from '@sigmasms/shared-types'

import { buttonModes, components, getISODate, icons, labelModes, popperPlacements } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'
import { tasksStates } from '@/components/services/tasks/utils'

function renderDialog(h) {
  const state = TaskStates.stopped

  let dialogMaxWidth
  if (this.viewport.breakpoint.mdUp) {
    dialogMaxWidth = 400
  }

  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate(`${Services.tasks}.titles.states.${state}`),
        value: this.showDialog,
        maxWidth: dialogMaxWidth
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    },
    [
      h(
        'div',
        {
          class: 'tasks-update__info'
        },
        [
          h(
            info,
            {
              props: {
                value: this.getTranslate(`${Services.tasks}.contents.confirm.states.${state}`),
                color: Colors.error
              }
            }
          )
        ]
      ),

      h(
        'div',
        {
          class: 'dialog__footer',
          slot: 'footer'
        },
        [
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.close'),
                mode: buttonModes.flat,
                disabled: this.loading
              },
              on: {
                click: () => {
                  this.showDialog = false
                }
              }
            }
          ),
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.stop'),
                color: Colors.error,
                loading: this.loading,
                disabled: this.loading
              },
              on: {
                click: () => {
                  this.updateTask(this.value.id, state)
                }
              }
            }
          )
        ]
      )
    ]
  )
}
function renderStopButton(h) {
  const state = TaskStates.stopped

  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        icon: tasksStates[state].icon,
        color: tasksStates[state].color,
        loading: this.loading,
        disabled: this.loading,
        tooltip: this.getTranslate(`${Services.tasks}.tooltips.states.${state}`)
      },
      scopedSlots: {
        dialog: () => {
          return renderDialog.call(this, h)
        }
      },
      on: {
        click: () => {
          this.showDialog = true
        }
      }
    }
  )
}
function renderPauseButton(h) {
  const state = TaskStates.paused

  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        icon: tasksStates[state].icon,
        color: tasksStates[state].color,
        loading: this.loading,
        disabled: this.loading,
        tooltip: this.getTranslate(`${Services.tasks}.tooltips.states.${state}`)
      },
      on: {
        click: () => {
          this.updateTask(this.value.id, state)
        }
      }
    }
  )
}
function renderButtons(h) {
  return h(
    'div',
    {
      class: 'tasks-update__buttons'
    },
    [
      renderPauseButton.call(this, h),
      renderStopButton.call(this, h)
    ]
  )
}
function renderScheduleMenu(h) {
  let scheduleButtonLabel
  if (this.computedDate) {
    scheduleButtonLabel = this.getTranslate(`${Services.tasks}.actions.schedule`)
  } else {
    scheduleButtonLabel = this.getTranslate(`${Services.tasks}.actions.start`)
  }

  return h(
    components.menu,
    {
      props: {
        rounded: true,
        offsetDistance: 8,
        placement: popperPlacements['bottom-end'],
        closeOnContentClick: false
      }
    },
    [
      h(
        button,
        {
          props: {
            mode: buttonModes.flat,
            icon: icons.play_arrow,
            color: Colors.success,
            loading: this.loading,
            disabled: this.loading,
            tooltip: this.getTranslate(`${Services.tasks}.tooltips.states.${TaskStates.scheduled}`)
          },
          slot: 'activator'
        }
      ),
      h(
        'div',
        {
          class: 'tasks-update__schedule'
        },
        [
          h(
            components['date-picker'],
            {
              props: {
                value: this.changeableDate.date,
                localeTag: this.locale,
                range: false,
                min: new Date().setDate(new Date().getDate() - 1),
                filter: dates => {
                  return dates.map(date => {
                    return date && getISODate(date)
                  })
                }
              },
              on: {
                input: event => {
                  this.changeableDate.date = event
                }
              }
            }
          ),
          h(
            'div',
            {
              class: 'tasks-update__time'
            },
            [
              h(
                components['text-field'],
                {
                  props: {
                    value: this.changeableDate.time,
                    type: 'time',
                    labelMode: labelModes.hidden,
                    dense: true,
                    details: false
                  },
                  on: {
                    input: event => {
                      this.changeableDate.time = event
                    }
                  }
                }
              )
            ]
          ),
          h(
            'div',
            {
              class: 'tasks-update__footer'
            },
            [
              h(
                button,
                {
                  props: {
                    label: scheduleButtonLabel,
                    loading: this.loading,
                    disabled: this.loading,
                    color: Colors.secondary
                  },
                  on: {
                    click: () => {
                      this.updateTask(this.value.id, TaskStates.scheduled, this.computedDate)
                    }
                  }
                }
              )
            ]
          )
        ]
      )
    ]
  )
}

export default function(h) {
  if (this.canUpdateTasksAsMeUp) {
    switch (this.value.state) {
      case TaskStates.running:
      case TaskStates.scheduled: return renderButtons.call(this, h)
      case TaskStates.paused: return renderScheduleMenu.call(this, h)
    }
  }
}
